"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Company = /*#__PURE__*/function () {
  function Company(client) {
    (0, _classCallCheck2["default"])(this, Company);
    this.client = client;
    this.resourceUrl = '/company';
  }

  (0, _createClass2["default"])(Company, [{
    key: "getIndividualSessionScheduling",
    value: function getIndividualSessionScheduling(groupId, coachId) {
      return this.client.post("/user/self-schedule", {
        groupId: groupId,
        coachId: coachId
      });
    }
  }]);
  return Company;
}();

exports["default"] = Company;